<template>
<div>
  {{index}}
  {{numeroTOL}}
  <a id="title" :href="document_url">{{ title }}</a>
  <i class="fas fa-lock" v-if="!allowed"></i>
  <div id="buttons" v-show="buttons_visible">
    <button id="show_quick_view" type="button" @click="showQuickView(id)" v-show="quickViewVisible"/>
    <button id="options_button" class=".dropdown-toggle" type="button" data-toggle="dropdown"/>

      <div class="dropdown-menu dropdown-menu-right dropdown-menu-sm" v-show="allowed">
      <a id="download_option" href="#" class="dropdown-item" @click="show_options('download')"/>
      <a id="print_option" href="#" class="dropdown-item" @click="show_options('print')"/>
      <a id="share_option" href="#" class="dropdown-item" @click="show_options('share')"/>
      <a id="save_option" v-show="saveOptionVisible" href="#" class="dropdown-item" @click='save_document'/>
    </div>
  </div>

  <documents-options-modal-vue ref="options_modal" />

  <div id="modal_user_subscriptions_case">
      <button class="btn btn-primary" id="save_case" type="button">Guardar</button>
  </div>

  <template v-if="isJurisprudenceSearch">
    <div id="descriptores">
      <li class="descriptor" :key="key" v-for="(value, key) in descriptores" />
    </div>
  </template>
  <template v-else>
    <div id="list_fields">
      <li class="list_field" :class="list_field_class(field)" :key="field.id" v-for="field in list_fields" />
    </div>
  </template>


  <documents-metadata-vue v-if="has_metadata_fields" :fields="metadata_fields" :search-attributes="searchAttributes" />
  <documents-concepts-vue v-if='mineDocSemanticas' :mine-concepts='mineDocSemanticas' :descriptores='retrieveDescriptores'/>
  <modal-quick-view-vue :bus="quickViewBus" :copy-buttons-visible="false" :search-type='searchAttributes.search_type' />
</div>
</template>

<script>
import mixins from 'common/mixins.js'
import filters from 'common/filters.js'
import document_mixin from 'common/mixins/document_mixin.js'
import Vue from 'vue'
import { mapGetters } from 'vuex'

const COVER_PATH = 'https://editorial.tirant.com/low'

export default {
  name: 'documents-item-vue',
  props: {
    index: { type: Number, default: 0 },
    num_found: { type: Number, default: 0 },
    searchAttributes: { type: Object, default: () => { return {} } },
    search_tokens: { type: Array, default: () => [] },
    token_id: { type: String, default: '' },
    highlight: { type: Array, default: () => [] },
    tolgeo: { type: String, default: '' },
    hide_save_document: { type: Boolean, default: false },
    hide_quick_view: { type: Boolean, default: false },
    route: { type: String, default: null },
    allowed: { type: Boolean, default: true }
  },
  components: {
    'documents-metadata-vue': () => import(/* webpackChunkName: "[request]" */ 'components/documents/Metadata'),
    'modal-quick-view-vue': () => import(/* webpackChunkName: "[request]" */ 'components/ModalQuickView'),
    'documents-resumen-auto-fields-vue': () => import(/* webpackChunkName: "[request]" */ 'components/documents/ResumenAutoFields'),
    'documents-options-modal-vue': () => import(/* webpackChunkName: "[request]" */ 'components/documents/OptionsModal'),
    'documents-concepts-vue': () => import(/* webpackChunkName: "[request]" */ 'components/documents/Concepts'),
  },
  data() {
    return {
      quickViewBus: new Vue(),
      current_body_fields: this.body_fields || [],
      current_header_fields: [],
      current_indice_fields: [],
      current_metadata_fields: [],
      current_selected_option: this.selected_option,
      loading_body_fields: false,
      cover_url: this.format_cover_url(this.cover),
      current_redaccion_id: this.id
    }
  },
  computed: {
    doc_pie_class() {
      if(this.has_highlight)
        return 'doc_pie--highlight'
      return ''
    },
    show_map() {
      return this.clazz == 'Jurisprudencia' && this.is_tolgeo_mex
    },
    index_is_odd() {
      return (this.index % 2) != 0
    },
    index_identifier() {
      return `doc_${this.index}`
    },
    text_to_share() {
      return `${this.share_text}\n\n${this.$grails_host}${this.url_for_get_file_without_params}`
    },
    concepts_visible() {
      return this.mine != undefined && this.mine['doc-semanticas_tes'] != undefined && this.mine['doc-semanticas_tes'].length > 0
    },
    mine_concepts() {
      if (!this.concepts_visible)
        return ''

      let concepts = this.mine['doc-semanticas_tes'].sort((a, b) => { return b.s - a.s })
      let concatConcepts = concepts.slice(0, 3).map(concept => concept.v).join(', ').replaceAll('-',' ')

      return (concatConcepts.replace(/(^\w)/g, m => m.toUpperCase()))
    },
    mineResumen() {
      return (this.mine || {})['resumen']
    },
    mineDocSemanticas() {
      return (this.mine || {})['doc-semanticas_tes']
    },
    retrieveDescriptores() {
      return this.descriptores
    },
    has_file_fields() {
      return (this.file_fields || []).length > 0
    },
    has_metadata_fields() {
      return this.metadata_fields.length > 0
    },
    buttons_visible() {
      return this.clazz != 'bibliotecavirtual' && this.clazz != 'TipoDoctrina'
    },
    hasSearchTokens() {
      return this.search_tokens.length > 0
    },
    has_highlight() {
      return (this.highlight || []).length > 0
    },
    is_derogada() {
      return this.list_fields.some(
        field => field.id === 'derogada' && field.normalized_value != 'vigente'
      )
    },
    nonBooleanListFields(){
      return this.list_fields.filter((val) => { return val.value_type != 'boolean' })
    },
    document_url() {
      let url = ''
      let params = {}
      if (this.route) {
        params['route'] = this.route
      }

      if (this.clazz == 'TipoDoctrina') {
        if (this.group_ids.length == 1) {
          Object.assign(params, { librodoctrina: this.id, general: this.search_tokens.join(' ') })

          url = this.url_for_document(this.group_ids[0], params)
        } else {
          Object.assign(params, { token_id: this.token_id })

          url = this.url_for_librodoctrinas_show(this.id, params)
        }
      } else if (this.token_id) {
        Object.assign(params, { token_id: this.token_id, index: this.index, docid: this.id })

        url = this.tolweb_url_for_search_navigate(this.searchAttributes.search_type, params)
      } else {
        url = gon.sofia?.document_detail_on_rails
          ? this.url_for_rails_documento_show(this.id, params)
          : this.url_for_grails_documento_show(this.id, params)
      }

      return url
    },
    has_indice_virtual() {
      return this.indice_virtual ? this.indice_virtual.length > 0 : false
    },
    optionsModal() {
      var modal = this.$refs.options_modal
      return Array.isArray(modal) ? modal[0] : modal
    },
    saveOptionVisible() {
      return !this.hide_save_document
    },
    classItemDetails(){
      if(this.has_highlight){
        return ''
      }
      return 'flex-lg-row'
    },
    hubExists(){
      return gon.controller_name == 'indice' && gon.current_id != undefined
    },
    quickViewVisible(){
      return !this.hide_quick_view && this.allowed
    },
    indice_virtual_style() {
      let style = 'doc_indice_virtual'
      return style + (gon.paisiso == 'per' ? ' multiple m-1 p-3 ' : ' m-3 p-3')
    },
    isJurisprudenceSearch() {
      return this.searchAttributes.search_type == 'jurisprudencia'
    },
    ...mapGetters('search', [
      'cleanedTokens'
    ]),
  },
  methods: {
    art_url(article) {
      let art_num = article.art_num
      let hashtag
      let params = {}
      if (this.route) {
        params['route'] = this.route
      }

      if(art_num)
        hashtag = `art_${art_num}`
      else
        hashtag = article.id
      return gon.sofia?.document_detail_on_rails
        ? this.url_for_rails_documento_show(this.id, params, hashtag)
        : `${this.url_for_grails_documento_show(this.id, params)}#${hashtag}`
    },
    showQuickView(id){
      this.quickViewBus.$emit('quick_view:show_document', String(id), '')
    },
    show_options(mode='download') {
      this.optionsModal.showModal()
      this.optionsModal.selectOption(mode)
      this.fetch_body_fields()
    },
    hide_options() {
      this.optionsModal.hideModal()
    },
    format_highlight(html) {
      return `... ${html} ...`
    },
    fetch_body_fields() {
      if (this.current_body_fields.length == 0) {
        this.loading_body_fields = true
        this.http_get({
          url: this.url_for_search_show(this.id),
          success: this.map_body_fields,
          fail: this.close_all
        })
      }
    },
    map_body_fields(response) {
      this.loading_body_fields = false
      if (response.data) {
        this.current_redaccion_id = response.data.current_redaccion_doc_id || this.id
        this.current_body_fields = response.data.body_fields
        this.current_header_fields = response.data.header_fields
        this.current_indice_fields = response.data.indice_fields
        this.current_metadata_fields = response.data.metadata_fields
      } else {
        alert('Error al recuperar las secciones del documento')
      }
    },
    close_all() {
      this.loading_body_fields = false
      this.optionsModal.hideModal()
    },
    save_document(){
      this.$emit('save:document', {'document[idTol]': this.id, 'document[formattedTol]': this.numeroTOL})
    },
    format_cover_url(file_name) {
      if(this.searchAttributes.search_type == 'bibliotecavirtual'){
        return file_name
      }
      return `${COVER_PATH}/${file_name}.jpg`
    },
    set_default_cover_url() {
      var file_name = 'notavailable'
      var editorial = this.list_fields.find((field) => { return field.id == 'editorial' })
      if (editorial && editorial.value == 'Palestra')
        file_name = 'notavailable-palestra'
      this.cover_url = this.format_cover_url(file_name)
    },
    separatorVisible(index) {
      if (this.isJurisprudenceSearch) {
        return index < Object.keys(this.descriptores).length - 1
      } else {
        return index < this.nonBooleanListFields.length - 1
      }
    },
    list_field_class(field) {
      if (field.normalized_value)
        return `list_field_${field.id}_${field.normalized_value}`
      else
        return ''
    },
    descriptorTranslation(descriptor) {
      return this.t(`documents.descriptores.${gon.paisiso}.${descriptor}`,
        {
          defaultValue: this.t(
            `documents.descriptores.default.${descriptor}`,
            { defaultValue: descriptor }
          )
        }
      )
    }
  },
  filters: {
    char_limit : filters.char_limit,
    clean_bolds: filters.clean_bolds,
    highlight : filters.highlight,
    parse_format_date: filters.parse_format_date,
    remove_intro_chars: filters.remove_intro_chars,
    format_field_value_to_string: filters.format_field_value_to_string,
    limit_string_length: filters.limit_string_length,
    format_descriptor_date: filters.format_descriptor_date
  },
  mixins: [mixins.internationalization, document_mixin, mixins.translate],
  mounted() {
    document.addEventListener('click', (event) => {
      if (event.target.matches('.tol_link')) {
        let id = event.target.getAttribute('data-docid')
        window.location.assign(
          gon.sofia?.document_detail_on_rails
            ? this.url_for_rails_documento_show(id)
            : this.url_for_grails_documento_show(id)
        )
      }
    })
  }
}
</script>

<style scoped>

</style>
